import * as React from "react";

const SearchIcon: React.FC = () => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.7258 10.3986L8.9203 7.59313C9.55827 6.64602 9.87304 5.46266 9.70452 4.20173C9.41718 2.05696 7.65936 0.311569 5.51248 0.0397644C2.32052 -0.364134 -0.363543 2.31993 0.0403792 5.51188C0.312255 7.65969 2.05788 9.41891 4.20289 9.70485C5.46383 9.87334 6.64742 9.55869 7.5943 8.92063L10.3998 11.7261C10.7659 12.0922 11.3595 12.0922 11.7256 11.7261C12.0914 11.3595 12.0914 10.7642 11.7258 10.3986ZM1.85388 4.87438C1.85388 3.22016 3.19967 1.87438 4.85389 1.87438C6.50811 1.87438 7.85389 3.22016 7.85389 4.87438C7.85389 6.5286 6.50811 7.87438 4.85389 7.87438C3.19967 7.87438 1.85388 6.52907 1.85388 4.87438Z" fill="#262525"/>
        </svg>        
    );
};

export default React.memo(SearchIcon);
